<ng-template #contentTemplate>
  <i class="metric-card__icon pi {{ model().icon }}" aria-hidden="true"></i>
  <span class="metric-card__label">{{ model().label }}</span>
  @if (loading()) {
    <span class="metric-card__value metric-card__value--loading" aria-hidden="true">—</span>
  } @else {
    <span class="metric-card__value-row">
      <span class="metric-card__value">{{ model().value }}</span>
      <!-- Aditivo: slot nomeado por atributo, ao lado do valor (ex. badge "ONLINE"). Sem
           nada com `metricCardInlineBadge` projetado, nenhum consumidor existente muda. -->
      <ng-content select="[metricCardInlineBadge]"></ng-content>
    </span>
  }
  @if (model().subtitle) {
    <span class="metric-card__subtitle">{{ model().subtitle }}</span>
  }
  <!-- Aditivo: sem nada projetado aqui, nenhum consumidor existente muda. Some durante o
       loading para não mostrar um extra (badge/barra) desatualizado junto do valor "—". -->
  @if (!loading()) {
    <ng-content></ng-content>
  }
</ng-template>

@if (clickable()) {
  <button
    type="button"
    class="metric-card metric-card--{{ model().severity }}"
    (click)="onActivate()">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </button>
} @else {
  <div class="metric-card metric-card--{{ model().severity }}" [attr.aria-busy]="loading() || null">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>
}
